var React = require('react');

var CheckboxGroup = require('react-checkbox-group');
var DestinationSettings = require('./destination-settings');
var DestinationFilterController = require('./destination-filter-controller');
var ToggleButton = require('./../ui-components/toggle-button');

var DestinationFilters = React.createClass(
  _.merge(DestinationFilterController, {
    getInitialState: function(){
      
      var current = this.props.getCurrentFilters(),
          currentSettings = {
            view: { selected: current.view },
            sort: { selected: current.sort },
            filter : { selected: _.clone(current.filter) }
          }

      var state = _.merge(DestinationSettings, currentSettings, { currentView: "hidden" });
      return state;
    },

    getButtons: function(type) {
      var buttons = [];
      for(var x in this.state[type].values){
        var options = this.state[type].values[x],
            active = x === this.state[type].selected,
            icon = this.state[type].icons[x];
        
        buttons.push(
          <a key={x} className={"btn btn-sm btn-days " + x + " " + (active ? "active" : "")} onClick={this.handleOptionChange.bind(this, x, type)}>
            <i className={ "fa " + icon } title={ options }></i>
          </a>
        );
      }

      return <div className="btns-filter">{buttons}</div>;
    },

    toggleFilterView: function(){
      this.setState({ currentView: this.state.currentView === "filters" ? "hidden" : "filters" })
    },

    render: function(){
      var self = this;

      var filterMarkup = _.map(this.state.filter.values, function(v, k){
        var active = self.state.filter.selected.indexOf(k) !== -1;

        return (
          <ToggleButton status={ active } id={ k } label={ v } onToggle={ self.toggleFilterSelections }></ToggleButton>
        );
      });

      var filterActive = this.state.filter.selected.length !== 0 || this.state.currentView === "filters";

      return (
        <div className='col-xs-6 col-sm-5 destination-filter-wrapper'>
          <div className='destination-filters'>
            <div className='filter filter-options'>
              <div classNam='param'>
                <div className='btns-filter'>
                  <a key="open-filter" className={"btn btn-sm btn-days open-filter " + (filterActive ? "active" : "") } onClick={this.toggleFilterView.bind(this)}>
                    <i className="fa fa-filter" title="Filter"></i>
                  </a>
                </div>
              </div>
              <div className={ "col-sm-4 col-xs-12 filter-popover " + (this.state.currentView === "filters" ? "active" : "") }>
                <div className="menu-pointer"></div>
                { filterMarkup }
                <div className="col-xs-12 buttons">
                  <button className="col-xs-6 clear btn" onClick={ this.clearFilters }>Clear All</button>
                  <button className="btn col-xs-12 apply btn" onClick={ function(){ self.applyChanges(); self.closeAll(); } }>Apply Filters</button>              
                  <button className="col-xs-6 cancel btn" onClick={ this.cancel }>Cancel</button>
                </div>
              </div>
            </div>
            <div className="filter view-options">
              <div className="param">
                { this.getButtons("view") }
              </div>
            </div>
            <div className="filter sort-options">
              <div className="param">
                { this.getButtons("sort") }
              </div>
            </div>
          </div>
        </div>
      );
    }
  })
);

module.exports = DestinationFilters;



// WEBPACK FOOTER //
// ./components/guide-components/destination-filters.js